<div class="root" #root>
@if (asset.video) {
    <div
        class="video_player"
        [style.margin-top.px]="margin"
        [style.width.px]="xform.elements[0][0]"
        [style.height.px]="xform.elements[1][1]"
        [class.bottom-padded]="!embedded"
    >
        <video #video controls="controls" loop="loop" class="video-js">
            <source type="video/mp4" src="{{ asset.video }}" />
        </video>
        @if (!embedded) {
            <div class="flex row info">
                <span class="flex-20">{{ frame }}/{{ frameCount }}</span>
                <span class="flex-60 center">{{ asset?.name }} - {{ asset?.author?.email }}</span>
                <span class="flex-20 end">{{ asset.framerate | number }} fps</span>
            </div>
        }
    </div>
} @else {
    <frog-video-processing class="flex"></frog-video-processing>
}
</div>
